<template>
  <div class="attentionMessage">
    <div class="attentionMessage__header">
      <ul class="attentionMessage__header__tab">
        <li class="attentionMessage__header__title" @click="switchTab('attention_post', $event)">
          @我的社区
          <span class="leftView__tab__count" v-if="message && message.unread_attention_post_count">{{message.unread_attention_post_count}}</span>
        </li>
        <li class="attentionMessage__header__title" @click="switchTab('attention_comment', $event)">
          @我的评论
          <span class="leftView__tab__count" v-if="message && message.unread_attention_comment_count">{{message.unread_attention_comment_count}}</span>
        </li>
        <span class="attentionMessage__header__arrow" :style="`left:${arrow_offsetLeft}px`"></span>
      </ul>
    </div>
    <div class="attentionMessage__items" v-if="fromType === 'attention_post'">
      <div class="postWrapper" v-for="item in data" :key="item.pk" @click="goPostDetail(item.record_data.pk)">
        <PostItem v-if="item.record_data" :dic="item.record_data" :owner-info="userInfo" from="attention"/>
      </div>
    </div>
    <div class="attentionMessage__items" v-else-if="fromType === 'attention_comment'">
      <MessageItem v-for="(item, index) in data" :key="index" :dic="item" :owner-info="userInfo"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MessageItem from "./components/MessageItem";
import PostItem from './components/PostItem'

import { types as MessageTypes } from "../store/modules/message";
import { types as CommunityTypes } from "../store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { types as ToastTypes } from "../store/modules/toast";

export default {
  name: "AttentionMessage",
  components: {
    MessageItem,
    PostItem
  },
  data() {
    return {
      fromType:'attention_post',
      arrow_offsetLeft:40,
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo,
      page: state => state.message.page,
      load_more: state => state.message.load_more,
      message:state => state.login.message,
    }),
    ...mapGetters({
      data: MessageTypes.GETTER_LIST_MESSAGE
    })
  },

  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW,
      loadLikeEvent:MessageTypes.LOAD_LIKE_EVENT
    }),
    ...mapActions({
      fetchData: MessageTypes.FETCH_LIST_MESSAGE,
      fetchCreateEvent:CommunityTypes.FETCH_CREATE_EVENT,
      fetchLikeEvent: CommunityTypes.FETCH_LIKE_EVENT,
      fetchDeleteEvent:MessageTypes.FETCH_DELETE_MESSAGE
    }),
    switchTab(fromType, e){
      this.arrow_offsetLeft = e.target.offsetLeft + 20;
      this.fromType = fromType;
      this.fetchData({page: 1, from:this.fromType})
    },
    // 去到帖子详情页
    goPostDetail(post_pk){
      this.$router.push(`/post/${post_pk}`);
    },

    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }
      
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchData({page: that.page+1, from:that.fromType})
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    },

    //-----------MessageItem 的回调事件
    //评论消息中的点赞回调事件
    likeEvent(type, data) {
      if(this.fromType === 'attention_comment'){
        data["type"] = type;
        console.log(data);
        this.fetchLikeEvent(data)
        this.loadLikeEvent(data)
      }else if(this.fromType === 'attention_post'){
        this.likeEvent1(type, data);
      }
    },
    //删除事件(删除的是消息)
    deleteEvent(pk){
      if(this.fromType === 'attention_comment'){
        this.fetchDeleteEvent(pk)
      }else if(this.fromType === 'attention_post'){
      }
    },
    //发帖子，对帖子评论，对评论回复
    publish(type, data) {
      data["type"] = type;
      this.fetchCreateEvent(data);
      console.log("评论成功");
      var dic = {
        message: "回复成功"
      };
      this.showToast(dic);
    },
    //-------------postItem 组件的回调函数
    // 发帖子，对帖子评论，对评论回复
    publish(type, data) {
      data["type"] = type;
      // console.log(data);
      this.fetchCreateEvent(data);
    },
    // 点赞
    likeEvent1(type, data) {
      data["type"] = type;
      this.fetchLikeEvent(data);
    },

    // 置顶帖子和取消
    stickyPost(type, data){
      data["type"] = type;
      this.fetchStickyEvent(data);
    },
    // 删除帖子、评论、回复
    deleteEvent1(type, data) {
      data["type"] = type;
      this.fetchDeleteEvent(data);
    },
    // 帖子送花
    flowerEvent(type, data) {
      data["type"] = type;
      this.fetchFlowerEvent(data);
    },
    // 帖子转发到朋友圈
    forwardEvent(type, data) {
      data["type"] = type;
      this.fetchForwardEvent(data);
    },
    // 关注/取关事件
    followEvent(type, data) {
      data["type"] = type;
      this.fetchFollowEvent(data);
    },
    // 加载更多评论事件
    loadMoreComment(post_id){
      this.$router.push(`/post/${post_id}`);
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    let type = this.$route.query.type;
    if (type === "post") {
      this.fromType = "attention_post";
    }else if(type === 'comment'){
      this.fromType = "attention_comment";
    }
    this.fetchData({page: 1, from:this.fromType})
  }
};
</script>

<style scoped lang="less">
.attentionMessage {
  width: 100%;
}
.attentionMessage__header {
  width: 100%;
  height: 38px;
  margin: 0 0 10px;
  box-shadow: -1px 0 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.04),
    1px 0 0 rgba(0, 0, 0, 0.04);
  background-color: #ffffff;
  font-size: 12px;
  color: #333333;
}
.attentionMessage__header__tab {
  width: 300px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.attentionMessage__header__title {
  width: 142px;
  margin: 0 -2px 0 20px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  height: 38px;
  line-height: 38px;
  /* font-weight: bold; */
  font-size: 12px;
  cursor: pointer;
  .leftView__tab__count{
    margin-left: 5px;
    min-width: 18px;
      height: 13px;
      line-height: 14px;
      text-align: center;
      display: inline-block;
      padding: 0 2px;
      color: #fff;
      border-radius: 3px;
      background-color: #FF6600;
      font-size: 8px;
  }
}
.attentionMessage__header__arrow {
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -7px;
  left: 40px;
  background-color: #ff6600;
  background-color: #f2f2f5;
}
.postWrapper{
  width: 100%;
  background-color: #ffffff;
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;
}
</style>
